import i18n from '@/utils/i18n';
import PaperCheckIcon from '@assets/icons/paper-check.svg';
import React from 'react';
import { CircledIcon } from '@/components/circled-icon';
import { createStyles } from '@/contexts/theme-context';
import { ListItem } from '@/components/list-item';

interface Props {
  onSelect: () => void;
}

export const RecordCheckPaymentFooter: React.FC<Props> = ({ onSelect }) => {
  const [styles] = useStyles();

  return (
    <ListItem
      item={{ title: i18n.t('record_check_payment'), value: '' }}
      listItemStyle={styles.listItem}
      onSelect={onSelect}
      renderLeftComponent={() => (
        <CircledIcon
          Icon={PaperCheckIcon}
          iconHeight={20}
          iconWidth={20}
          size="small"
        />
      )}
    />
  );
};

const useStyles = createStyles((theme) => ({
  listItem: {
    paddingHorizontal: theme.sk.spacing.spaceLarge,
  },
}));
